import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Option} from "../types/Option";

export const useGetOptions = (dealerID: number, prodQteGrpID: number, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-options', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-pro/options?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&zipCode=' + zipCode) as Option[],
        enabled: prodQteGrpID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
